import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import OrderStatusTimeline from "./OrderStatusTimeline";

const TimelinePopup = ({ isOpen, toggle, statusLogs, orderRef }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Order Status Timeline - Order #{orderRef}
      </ModalHeader>
      <ModalBody>
        <OrderStatusTimeline statusLogs={statusLogs} />
      </ModalBody>
    </Modal>
  );
};

export default TimelinePopup;